// extracted by mini-css-extract-plugin
export default {"cont_slide":"introStyle_cont_slide__ispY-","cont_slide_slide":"introStyle_cont_slide_slide__NqSfK"};